<template>
    <div v-if="!loadingCheck">
        <EmptyContent v-if="players.playerInfoList.length <=0 " content="검색결과가 없습니다" style="height: 500px;"></EmptyContent>
        <div class="player-list-wrap" v-else>
            <div class="player-list" v-for="(player, playerIndex) in players.playerInfoList" :key="playerIndex"  @click="$router.push(`/tournament/${player.tnmtId}/result/rank/${player.playingCategoryId}/${player.participantId}`)">
                <div class="player-wrap">
                    <p class="team-name">{{player.teamName}}</p>
                    <p class="player-name">{{player.playerName}}</p>
                    <p class="player-level">{{player.tnmtName}}</p>
                    <p class="player-level">{{player.eventName}} {{player.age}} {{player.level}}</p>
                </div>
                <span/>
            </div>
        </div>
    </div>
    <Spinner v-else></Spinner>

</template>
<script>
    import Spinner from "../common/Spinner";
    import {mapState} from 'vuex'
    import EmptyContent from "../common/EmptyContent";
    export default{
        components: {EmptyContent, Spinner},
        computed: {
            ...mapState('searches', ['players'])
        },
        data(){
          return{
              loadingCheck: false
          }
        },
        created() {


            this.loadingCheck = true
            const _this = this
            this.$store.dispatch('searches/playerSearch', {
                playerName: this.$route.query.playerName
            }).then(res => {
                _this.loadingCheck = false
            }).catch(err => {
                console.dir('searches/playerSearch err => ')
                console.dir(err)
                _this.loadingCheck = false
            })


        }
    }
</script>
